import { request } from "./http";

export interface LoginResponse {
  access_token: string;
  token_type: string;
}

export interface UserMe {
  id: string;
  email: string;
  is_active: boolean;
  is_verified: boolean;
  is_superuser: boolean;
  org_id: string;
  full_name: string | null;
  locale: string | null;
  totp_enabled: boolean;
}

export interface RegisterBody {
  email: string;
  password: string;
  org_id: string;
}

export const auth = {
  login: (username: string, password: string, totp_code?: string) =>
    request<LoginResponse>("/auth/jwt/login", {
      method: "POST",
      form: true,
      body: { username, password, totp_code },
      skipAuthExpiredOn401: true,
    }),
  logout: () => request<void>("/auth/jwt/logout", { method: "POST" }),
  register: (body: RegisterBody) => request<UserMe>("/auth/register", { body }),
  me: () => request<UserMe>("/users/me"),
};
